// Pre-fill WhatsApp link helper
export const normalizePhone = (p = "") => {
  const digits = (p.match(/\d/g) || []).join("");
  if (!digits) return "";
  if (digits.startsWith("0")) return "62" + digits.slice(1);
  if (digits.startsWith("62")) return digits;
  return "62" + digits;
};

export const waLink = (phone, message) =>
  `https://wa.me/${normalizePhone(phone)}?text=${encodeURIComponent(message)}`;

export const ADMIN_WA_PHONE = "+628119303015";
